<section
    class="prom-button-dropdown-overlay {overlayClass}"
    on:click={toggle}
>
</section>

<section
    class="prom-button-dropdown prom-dropdown__{position}"
    {id}
>
    <IconButton
        iconClass={cssClass}
        id="{id}-button"
        {iconOnly}
        {iconPlacement}
        {expanded}
        {large}
        {text}
        {textOnly}
        {type}
        {disabled}
        {ariaLabel}
        haspopup
        htmlType="button"
        on:click={toggle}
        on:keyup={keyUpHandler}
        on:keydown={keyDownHandler}
    />

    <Dropdown
        {arrow}
        {arrowPosition}
        {expanded}
        {items}
        {responsive}
        id="{id}-list"
        on:dropdownClose={closeHandler}
        on:submenuClose={submenuHandler}
        on:selectedOption
        >

        <section slot="header">
            <slot name="header"></slot>
        </section>

        <section slot="footer">
            <slot name="footer"></slot>
        </section>
    </Dropdown>

</section>

<script>
    import IconButton from '../../../inputs/IconButton/v1/IconButton.svelte';
    import Dropdown from '../../Dropdown/v1/Dropdown.svelte';
    import { focusFirstItemIn, hideOpenSubmenus, removeFocusFromParentDropdown } from '../../Dropdown/v1/dropdownHelper.js';
    import { Keys } from '@itslearning/atlas/keyboard/keys';
    import { normalizeKey } from '@itslearning/atlas/keyboard/normalize';
    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    $: arrowPosition = position === 'up' ? 'bottom' : 'top';
    $: cssClass = textOnly ?  '' : iconClass;
    $: overlayClass = responsive && expanded ? 'prom-button-dropdown-overlay--visible' : '';

    /** @type {boolean} */
    export let arrow = true;
    /** @type {string} */
    export let iconClass = 'prom-button-dropdown-icon';
    /** @type {boolean} */
    export let expanded = false;
    /** @type {boolean} */
    export let disabled = false;
    /** @type {boolean} */
    export let iconOnly = false;
    /** @type {'start'|'end'} */
    export let iconPlacement = 'start';
    /** @type {string} */
    export let id = 'button-dropdown';
    /** @type {Object[]} */
    export let items = [];
    /** @type {boolean} */
    export let large = false;
    /** @type {string} */
    export let position = 'down';
    /** @type {boolean} */
    export let responsive = true;
    /** @type {string} */
    export let text = 'ChangeMe';
    /** @type {boolean} */
    export let textOnly = true;
    /** @type {string} */
    export let type = 'primary';
    /** @type {string} */
    export let ariaLabel = undefined;

    function closeHandler({ detail: event }) {
        const buttonElement = document.querySelector('#' + id + '-button');

        if (buttonElement && buttonElement.contains(event.target)) {
            return;
        }

        const { key } = event;

        expanded = false;

        switch (normalizeKey(key)) {
            case Keys.ESCAPE:
                returnFocus();
                break;
            default:
                return;
        }
    }

    function submenuHandler(event) {
        event.stopPropagation();
        hideOpenSubmenus();
    }

    function keyDownHandler(event) {
        const { key } = event;

        switch (normalizeKey(key)) {
            case Keys.DOWN: {
                event.preventDefault();
                expanded = true;
                const dropdown = document.querySelector('#' + id);

                setTimeout(() => focusFirstItemIn(dropdown), 0);
                break;
            }
            case Keys.TAB:
                hideOpenSubmenus();
                removeFocusFromParentDropdown();
                expanded = false;
                break;
            case Keys.ENTER:
            case Keys.SPACE:
                event.preventDefault();
                toggle(event, true);
                break;
            default:
                return;
        }
    }

    function keyUpHandler(event) {
        const { key } = event;

        switch (normalizeKey(key)) {
            case Keys.ESCAPE:
                expanded = false;
                returnFocus();
                break;
        default:
            return;
        }
    }

    function toggle(event, setFocus = false) {
        event.preventDefault();
        dispatch('beforeToggle', event);

        expanded = !expanded;

        if (items.length && setFocus) {
            const dropdown = document.querySelector('#' + id);

            setTimeout(() => focusFirstItemIn(dropdown), 0);
        }
    }

    function returnFocus() {
        const buttonElement = document.querySelector('#' + id + '-button');

        buttonElement.focus();
    }
</script>
